import React from "react";
import AboutSection from "../components/AboutSection";
import ServicesSection from "../components/ServicesSection";
import ProjectsSection from "../components/ProjectsSection";

export default function Home() {
  return (
    <>
      <AboutSection />
      <ServicesSection />
      <ProjectsSection />
    </>
  );
}
